<template>
    <div class="bookConfig app-container">
        <div class="global-header-wrap">
            <h3>{{$t('org.store')}}</h3>
        </div>
        <el-card class="app-table-container" :body-style="{ padding: '20px' }">
            <div slot="header">
                <div class="global-table-header">
                    <div class="bookConfig-header-left">
                        <list-search @listSearchEvn="listSearchEvn"/>
                    </div>
                    <div class="bookConfig-header-right">
                        <button class="global-button-style" @click="$router.push({name: 'bookConfigBatch'})">{{$t('org.batch')}}</button>
                    </div>
                </div>
            </div>
            <div class="global-body-wrap">
                <appTable 
                :tableData="tableData" 
                :tableProps="tableProps" 
                :selectCtrl="true"
                @tableHandle="tableHandle"/>
            </div>

            <pagination
            :pageSize="params.limit"
            :total = "total"
            @pageNum="getPageNum"
            />
        </el-card>
    </div>
</template>

<script>
import listSearch from '@/components/listSearch'
import appTable from '@/components/appTable'
import pagination from '@/components/pagination'
import listMixin from '@/mixins/list'
export default {
    components: {
        listSearch,
        appTable,
        pagination
    },
    computed: {
        tableProps() {
            let tableProps = [{
                prop: 'name',
                label: this.$t('org.orgName')
            },  {
                prop: 'tag',
                label: this.$t('org.tag')
            }, {
                prop: 'channel',
                label: this.$t('org.channel')
            }, {
                prop: 'module',
                label: this.$t('org.frame')
            }, {
                prop: 'banner',
                label: this.$t('org.banner')
            }, {
                prop: 'handle',
                label: this.$t('commonMsg.handle'),
                btn: [this.$t('commonMsg.edit')]
            }]
            return tableProps
        }
    },
    mixins:[listMixin],
    data() {
        return {
            params: {
                limit:20,
                offset:0
            },
            tableData: [],
            total: 0
        }
    },

    methods: {
        getList() {
            this.$http.getOrgList(this.params)
            .then(res => {
                this.tableData = res.data.rows
                this.total = res.data.count
            })
        },

        edit(data) {
            this.$router.push({name: 'bookConfigEdit', query: {id: data.row.id}})
        }
    }
}
</script>

<style lang="scss" scoped>
.bookConfig{
    .bookConfig-header{
        padding:10px 20px;
        display: flex;
        justify-content: space-between;
    }
    .bookConfig-pagination{
        padding:10px;
        text-align: right;
    }
}
</style>

